import { ResultData } from './../types/axios.d';
import type { GetVacationProductListParam, GetVacationProductListData, GetVacationFilterData, GetVacationHomeData } from './model/product';
// import { http } from "@/libs/axios.js";
import Vue from "vue";
import {GetVacationFilterParam} from "./model/product";

export const vacationAPI = {
  productFilter: "product/product/line-filter",
  productList: "product/product/line-list",
  productDetail: "product/product/line-info",
  productDates: "product/product/line-dates",
  productDst: "product/product/line-date-dst", // 产品出发地
  productPrices: "product/product/line-date-dst-prices",

  bookingInfo: "order/submit/line-booking-info",

  createOrder: "order/submit/line-create"
  // procueBooking: '/order/submit/line-booking'
};

export function getVacationHome() {
  return Vue.$axios.$post<ResultData<GetVacationHomeData>>('pc/index/vacation-index')
  // return Vue.$axios.$post<ResultData<GetVacationHomeData>>('pc/index/index')
}

export function getProductFilter(data: GetVacationFilterParam = {}) {
  return Vue.$axios.$post<ResultData<GetVacationFilterData>>(vacationAPI.productFilter, { data });
}

export function getProductVacationDates() {
  return Vue.$axios.$get<ResultData<string[]>>('product/product/line-calendar')
}

export function getProductList(data: GetVacationProductListParam) {
  return Vue.$axios.$post<ResultData<GetVacationProductListData>>(vacationAPI.productList, { data });
}

export function getProductDetail(data: any = {}) {
  return Vue.$axios.$post(vacationAPI.productDetail, { data });
}

export function getProductDates(data: any = {}) {
  return Vue.$axios.$post(vacationAPI.productDates, { data });
}

// 获取出发地
export function getProductDst(data: any = {}) {
  return Vue.$axios.$post(vacationAPI.productDst, { data });
}

// 获取价格
export function getProductPrices(data: any = {}) {
  return Vue.$axios.$post(vacationAPI.productPrices, { data });
}

export function getBookingInfo(data: any = {}) {
  return Vue.$axios.$post(vacationAPI.bookingInfo, { data });
}

export function createOrder(data: any = {}) {
  return Vue.$axios.$post(vacationAPI.createOrder, { data });
}
